/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import AppStorage from '@app/lib/AppStorage';
import {makeAutoObservable} from 'mobx';

const STORAGE_KEY = 'ErrorTrackingPreferencesStore';

class ErrorTrackingPreferencesStore {
	sentryEnabled = true;

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
		this.hydrate();
	}

	private hydrate(): void {
		const snapshot = AppStorage.getJSON<{sentryEnabled?: boolean}>(STORAGE_KEY);
		if (typeof snapshot?.sentryEnabled === 'boolean') {
			this.sentryEnabled = snapshot.sentryEnabled;
		}
	}

	waitForInit(): Promise<void> {
		return Promise.resolve();
	}

	getSentryEnabled(): boolean {
		return this.sentryEnabled;
	}

	setSentryEnabled(enabled: boolean): void {
		this.sentryEnabled = enabled;
		AppStorage.setJSON(STORAGE_KEY, {sentryEnabled: enabled});
	}
}

export default new ErrorTrackingPreferencesStore();
